import { render, staticRenderFns } from "./MoreSmsActions.vue?vue&type=template&id=b3cffcf4&scoped=true"
import script from "./MoreSmsActions.vue?vue&type=script&lang=js"
export * from "./MoreSmsActions.vue?vue&type=script&lang=js"
import style0 from "./MoreSmsActions.vue?vue&type=style&index=0&id=b3cffcf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cffcf4",
  null
  
)

export default component.exports